import React, { useState, useEffect } from 'react'
// import { useLocation } from 'react-router-dom'
import { Layout } from 'antd'
// import routes from 'routes'

const Header = () => {
  const [title, setTitle] = useState()
  // const location = useLocation()
  //
  // useEffect(() => {
  //   const activeRoute = routes.find(route => route.path === location.pathname)
  //
  //   if (activeRoute) {
  //     // @ts-ignore
  //     setTitle(activeRoute.title)
  //   }
  // }, [location.pathname])

  return title ? (
    <Layout.Header style={{ background: '#fff', padding: '0px 20px' }}>
      <h2>{title}</h2>
    </Layout.Header>
  ) : null
}

export default Header
